module.exports = __webpack_public_path__ + "img/sideflag.6efbdfe.png";